import Glide from '@glidejs/glide'

(function(window, document) {
    'use strict';

    if(document.getElementById('tech-slider')) {
        var tech_slider = new Glide('#tech-slider').mount();

        tech_slider.on('move.after', function (moveAmount) {
            let activeEl = document.getElementById('tech-slider').querySelectorAll('.glide__slide--active a');
            var disable_elements = document.getElementById('tech-slider').querySelectorAll(".glide__slide a");

            disable_elements.forEach((userItem) => {
                userItem.tabIndex = -1;
            });
            activeEl.forEach((userItem) => {
                userItem.tabIndex = 0;
            });
        });
    }

})(window, document, Glide);
